/**
 * Mamba 🐍
 * Creating access to affordable therapy.
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/* An enumeration. */ /**
 * An enumeration.
 */
export enum LanguageToReadableLabel {
  ALBANIAN = 'Albanian',
  AMERICAN_SIGN_LANGUAGE = 'American Sign Language',
  ARABIC = 'Arabic',
  ARMENIAN = 'Armenian',
  ASSAMESE = 'Assamese',
  BENGALI = 'Bengali',
  BOSNIAN = 'Bosnian',
  BULGARIAN = 'Bulgarian',
  CANTONESE = 'Cantonese',
  CROATIAN = 'Croatian',
  DANISH = 'Danish',
  DUTCH = 'Dutch',
  ENGLISH = 'English',
  FARSI = 'Farsi',
  FLEMISH = 'Flemish',
  FRENCH = 'French',
  FUZHOUNESE = 'Fuzhounese',
  GERMAN = 'German',
  GREEK = 'Greek',
  GUJARATI = 'Gujarati',
  HAITIAN_CREOLE = 'Haitian Creole',
  HEBREW = 'Hebrew',
  HINDI = 'Hindi',
  HMONG = 'Hmong',
  HUNGARIAN = 'Hungarian',
  ICELANDIC = 'Icelandic',
  IGBO = 'Igbo',
  ITALIAN = 'Italian',
  JAPANESE = 'Japanese',
  KASHMIRI = 'Kashmiri',
  KOREAN = 'Korean',
  KURDISH = 'Kurdish',
  MALAYALAM = 'Malayalam',
  MANDARIN = 'Mandarin',
  MARATHI = 'Marathi',
  NORWEGIAN = 'Norwegian',
  POLISH = 'Polish',
  PORTUGUESE = 'Portuguese',
  PUNJABI = 'Punjabi',
  ROMANIAN = 'Romanian',
  RUSSIAN = 'Russian',
  SERBIAN = 'Serbian',
  SHONA = 'Shona',
  SOMALI = 'Somali',
  SPANISH = 'Spanish',
  SWAHILI = 'Swahili',
  TAGALOG = 'Tagalog',
  THAI = 'Thai',
  TURKISH = 'Turkish',
  TWI = 'Twi',
  UKRAINIAN = 'Ukrainian',
  URDU = 'Urdu',
  VIETNAMESE = 'Vietnamese',
  YIDDISH = 'Yiddish',
  YORUBA = 'Yoruba',
}
